<script>
import RoomTable from '../components/RoomTable'

export default {
  name: 'RoomControl',
  components: {
    RoomTable,
  },
  data() {
    return {
      form: {
        rooms: [],
      },
      error: {},
    }
  },
  methods: {
    onRoomInserted(index) {
      this.copyNewRoom(index)
      this.reIndexRoomNumber()
    },
    onRoomUpdated() {
      this.reIndexRoomNumber()
    },
    onRoomReplaced(sourceIndex, destinationIndex) {
      const targetVal = this.form.rooms[sourceIndex]
      this.form.rooms.splice(sourceIndex, 1)
      this.form.rooms.splice(destinationIndex, 0, targetVal)
      this.reIndexRoomNumber()
    },
    onRoomRemoved(index) {
      this.form.rooms.splice(index, 1)
      this.reIndexRoomNumber()
    },
    onRoomDisabled(index) {
      this.$set(this.form.rooms[index], 'disable_field_survey', 1)
    },
    onRoomEnable(index) {
      this.$set(this.form.rooms[index], 'disable_field_survey', 0)
    },
    onCopyRenovationYear1(index) {
      const currentRoomFieldRenovationYear = this.$route.name === 'fieldSurveyEditStep2'
        ? this.form.rooms[index].field_renovation_year1
        : this.form.rooms[index].renovation_year1
      for (let i = index + 1; i < this.form.rooms.length; i += 1) {
        if (!this.form.rooms[i]) {
          return
        }
        this.$set(this.form.rooms[i],
          this.$route.name === 'fieldSurveyEditStep2'
            ? 'field_renovation_year1'
            : 'renovation_year1',
          currentRoomFieldRenovationYear)
      }
    },
    onCopyRenovationYear2(index) {
      const currentRoomFieldRenovationYear = this.$route.name === 'fieldSurveyEditStep2'
        ? this.form.rooms[index].field_renovation_year2
        : this.form.rooms[index].renovation_year2
      for (let i = index + 1; i < this.form.rooms.length; i += 1) {
        if (!this.form.rooms[i]) {
          return
        }
        this.$set(this.form.rooms[i],
          this.$route.name === 'fieldSurveyEditStep2'
            ? 'field_renovation_year2'
            : 'renovation_year2',
          currentRoomFieldRenovationYear)
      }
    },
    copyNewRoom(index) {
      const room = this.form.rooms.length > 0
        ? this.form.rooms[index]
        : {}
      this.form.rooms.splice(index + 1, 0, {
        room_no: '',
        completion_year: room.completion_year ?? '1975',
        renovation_year1: room.renovation_year1 ?? null,
        renovation_year2: room.renovation_year2 ?? null,
        floors: room.floors ?? 1,
        room_name: '',
        field_completion_year: room.completion_year ?? null,
        field_renovation_year1: room.renovation_year1 ?? null,
        field_renovation_year2: room.renovation_year2 ?? null,
        field_floors: room.floors ?? 1,
        field_room_name: '',
      })
    },
    reIndexRoomNumber(skipIndex = null) {
      const floors = {}
      this.form.rooms.forEach((item, index) => {
        floors[item.floors] = (floors[item.floors] ?? 0) + 1
        // ハイフンが二つ以上ある場合は枝番の部屋とみなして再採番はスキップ
        if (skipIndex === index || item.room_no.split('-').length > 2) {
          this.$set(this.form.rooms[index], 'sort_index', `${floors[item.floors]}`)
          return
        }
        const number = `${floors[item.floors]}`.padStart(3, '0')
        if (item.floors === 99) {
          this.$set(this.form.rooms[index], 'room_no', `RF-${number}`)
        } else {
          this.$set(this.form.rooms[index], 'room_no', item.floors > 0
            ? `F${item.floors}-${number}`
            : `B${Math.abs(item.floors)}-${number}`)
          this.$set(this.form.rooms[index], 'sort_index', `${floors[item.floors]}`)
        }
      })
    },
  },
}
</script>
